module.exports = __webpack_public_path__ + "static/thiem-red-b53095eac9605f2fd5e08d3143de6027.png";